/**
 * Lazy Leaflet CDN loader — legacy (non-tile) mode only.
 *
 * Leaflet used to be a static <script>/<link> pair in index.html, which
 * made EVERY visitor pay for it. Tile mode (manifest `tiles` present)
 * renders with bundled MapLibre instead, so the CDN tags moved here and
 * are injected only when the legacy GeoJSON path actually runs
 * (national-scale contract: "Remove the Leaflet CDN dependency in tile
 * mode; keep the code path switchable by manifest tiles presence").
 *
 * Same URLs + SRI hashes as the old index.html tags. Idempotent; the
 * legacy init effect keeps its window.L polling loop, so this only has
 * to kick off the fetch.
 */

const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
const LEAFLET_JS_SRI = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_CSS_SRI = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';

let injected = false;

export function ensureLeafletLoaded(): void {
  if (typeof document === 'undefined') return;
  if (injected || (window as { L?: unknown }).L) return;
  injected = true;

  if (!document.querySelector(`link[href="${LEAFLET_CSS}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = LEAFLET_CSS;
    link.integrity = LEAFLET_CSS_SRI;
    link.crossOrigin = '';
    document.head.appendChild(link);
  }
  if (!document.querySelector(`script[src="${LEAFLET_JS}"]`)) {
    const script = document.createElement('script');
    script.src = LEAFLET_JS;
    script.integrity = LEAFLET_JS_SRI;
    script.crossOrigin = '';
    script.defer = true;
    document.head.appendChild(script);
  }
}
